<template>
  <div class="nav-bar" :class="{ 'underline': !isMenuOpen }">
    <div class="left-zone">
      <md-button class="md-icon-button menu-button" @click="onMenuClick">
        <md-icon>menu</md-icon>
      </md-button>
    </div>
    <div class="middle-zone">
      <transition name="collapse-menu">
        <ul class="links-zone" v-show="isScreenMediumSize | (isMenuOpen && !isScreenMediumSize)">
          <li>
            <div class="venture venture-services"></div>
          </li>
          <li>
            <a href="http://jumia.com" target="_blank" analytics-on="click" analytics-event="open-jumia">
              <div class="venture venture-jumia"></div>
            </a>
          </li>
          <li v-if="isZandoSelected">
            <a href="https://www.zando.co.za/" target="_blank" analytics-on="click" analytics-event="open-zando" class="za-icon">
              <img src="@/assets/images/zando.png" alt="Zando">
            </a>
          </li>
        </ul>
      </transition>
    </div>
    <div class="right-zone">
      <md-field class="language">
        <md-select @md-selected='onLanguageChange' v-model="selectedLanguage" name="language" id="language">
          <md-option class="language-item" v-for="language in languages" :key="language.name" :value="language.code">
            {{ language.name }}
          </md-option>
        </md-select>
      </md-field>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { LANGUAGES } from '@/configs/constants'

export default {
  name: 'NavBar',
  data () {
    return {
      languages: null,
      selectedLanguage: null,
      isMenuOpen: false,
      isScreenMediumSize: false
    }
  },
  computed: {
    ...mapState('location', [
      'language'
    ]),
    ...mapGetters('location', [
      'isZandoSelected'
    ])
  },
  watch: {
    language () {
      this.selectedLanguage = this.language
    }
  },
  methods: {
    ...mapActions('location', [
      'setLanguage'
    ]),
    onLanguageChange () {
      if (this.selectedLanguage !== this.language) {
        this.setLanguage({ language: this.selectedLanguage })
      }
    },
    onMenuClick () {
      this.isMenuOpen = !this.isMenuOpen
    },
    onWindowResize () {
      const mediumScreenSize = 768
      if (window.innerWidth > mediumScreenSize && this.isMenuOpen) {
        this.isMenuOpen = false
      }
      if (window.innerWidth > mediumScreenSize && !this.isScreenMediumSize) {
        this.isScreenMediumSize = true
      }
      if (window.innerWidth <= mediumScreenSize && this.isScreenMediumSize) {
        this.isScreenMediumSize = false
      }
    }
  },
  mounted () {
    this.languages = LANGUAGES
    this.selectedLanguage = this.language
    this.onWindowResize()
  },
  created () {
    window.addEventListener('resize', this.onWindowResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onWindowResize)
  }
}
</script>

<style scoped lang="sass">
.underline
  border-bottom: 1px solid #AAA

.nav-bar
  width: 100%
  text-align: center
  height: 46px
  background: #FFFFFF

  .left-zone
    float: left
  .middle-zone
    display: inline-block
    margin: 0 auto
  .right-zone
    float: right

.links-zone
  @media (max-width: $medium-device-width)
    max-height: 200px
    position: absolute
    top: 46px
    z-index: 11
    background-color: white
    left: 0
    border-bottom: 1px solid #AAA
    padding-bottom: 10px
    width: 100%
  &.menu-active
    @media (max-width: $medium-device-width)
      display: block

  margin: 0
  padding: 0
  list-style-type: none
  padding-top: 14px
  li
    display: inline-block
    &:not(:nth-child(1))
      -webkit-filter: grayscale(100%)
      filter: grayscale(100%)
      margin-left: 35px
      @media (max-width: $large-device-width)
        margin-left: 0px
      @media (max-width: $medium-device-width)
        margin: 5px
    &:nth-child(1)
      @media (max-width: $medium-device-width)
        margin: 5px
    &:hover
      -webkit-filter: grayscale(0)
      filter: grayscale(0)

.menu-button
  margin-top: 3px
  display: none
  @media (max-width: $medium-device-width)
    display: block

.language
  text-align: right
  margin: -10px 10px 0 0
  width: 100px

.venture
  background-image: url(../assets/images/venture-logos.svg)
  background-repeat: no-repeat
  width: 90px
  height: 15px
  display: block
.venture-services
  background-position: 0 -8px
.venture-jumia
  background-position: 10px -29px
.za-icon
  img
    width: 55px
    margin: -7px 0 0 0

.collapse-menu-enter-active, .collapse-menu-leave-active
  transition: all .5s
.collapse-menu-enter, .collapse-menu-leave-to /* .fade-leave-active below version 2.1.8 */
  max-height: 0
  opacity: 0
  padding: 0
</style>
